import RefBooksModule from './refbooks.module';
import Collection from '../../collection';
import Grid from '../../view/grid';
import Sticker from '../../model/sticker';
import Types from '../../collection/refbooks/types';

import Config from '../../config';

import { roleA, roleC } from '../../roles';
import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock  } from '../../loader';





const 
    OPEN_STICKER = 'sticker-form--popup';





export default RefBooksModule.extend( {

    template: 'module/refbooks/stickers.form',

    url() {
        return this.options.sticker.id
            ? `stickers/${this.options.sticker.id}/edit`
            : `stickers/new`;
    },

    open(sticker) {
        this.options.sticker = sticker, this.options.original = sticker.clone();
        if (!sticker.id)
            if (this.state().cluster && this.state().cluster.id != -1)
                sticker.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                sticker.set( 'cluster', Config.cluster() );

        this.options.sorted = new Types();
        this.options.filtered = new Types();
        this.options.resulted = new Types();

        return Grid.sort( this.state(), this.options.types, this.options.sorted )
            .then( () => this.reFilterGrid() )
            .then( () => this.bind( sticker ) );
    },

    start() {
        this.listenTo( this.options.sticker, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            this.reFilterGrid();
        } );
        this.listenTo( this.model, 'change',
            () => this.$( '.-save' )[0].disabled = !this.hasDiff() );
        this.listenTo( this.model, 'change:is_for_all',
            () => this.TypeGrid.enable( this.model.get( 'is_for_all' ) === 'f' ) );

        return this;
    },

    stop() {
        return this.stopListening( this.model ), this;
    },

    serialize() {
        const { sort, direction, search: searchString, } = this.state();
        const { filtered, resulted } = this.options;
        const { clusters } = this.options;

        return {
            searchString, sort, direction,
            hasDiff: this.hasDiff(),
            clusters, types: filtered, rows: resulted,
        };
    },

    diff(options = {}) {
        const { sticker, original } = this.options;
        const baseDiff = sticker.diff( original, options )
            .filter( ({ attrName }) => attrName !== 'types');

        const oldValue = original.get( 'types' );
        const newValue = sticker.get( 'types' );

        const originalTypes = oldValue
            .map( id => +id ).sort();
        const stickerTypes = newValue
            .map( id => +id ).sort();

        if ('' + originalTypes === '' + stickerTypes)
            return baseDiff;

        return [...baseDiff, {
            attrName: 'types',
            oldValue, newValue
        }];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    reFilterGrid() {
        const { sticker, sorted, filtered, resulted } = this.options;
        Grid.filter( this.state(), 
            sticker.get( 'cluster' ), sorted, filtered, resulted );
    },

    events: {

        'click .-save'() {
            let toSave = this.model.clone();

            if (this.diff().filter( ({ attrName }) => attrName === 'types' )) {
                const { sticker, original } = this.options;
                const cluster = sticker.get( 'cluster' );

                const availableToChange = hashify(
                    getAvailableFilteredTypeIds.call( this, this.options.sorted
                        .models.filter( type =>
                            !cluster || !type.get( 'cluster' ) || type.get( 'cluster' ).id == cluster.id ) ) );
                
                const after = hashify( sticker.get( 'types' ) );
                const applyRemove = original.get( 'types' )
                    .filter( id => after[id] || !availableToChange[id] );

                const before = hashify( original.get( 'types' ) );
                const applyAdd = sticker.get( 'types' )
                    .filter( id => !before[id] && availableToChange[id] );

                toSave.set( 'types', [...applyRemove, ...applyAdd] );
            }

            beginLock( this );
            
            // cannot invoke model.save() because
            // "news_type_ids" prop from server
            // breaks `this.get( 'types' ) code`
            return this.options.stickers.save( toSave )
                .then( attrs => new Sticker( attrs ) ).then( 

                    (/*sticker*/) => this.trigger( RefBooksModule.BACK ), 

                    message => {
                        endLock( this );
                        handle( this, error( message ) );
                    } );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;
            const { types, sorted, } = this.options;

            return this.setState( { page: 1, sort, direction, } ),
                Grid.sort( this.state(), types, sorted, )
                    .then( () => this.reFilterGrid() )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { sticker, filtered, } = this.options;

            const needAppend = currentTarget.checked;
            const oldTypes = sticker.get( 'types' );
            const newTypes = needAppend
                ? [...oldTypes, id]
                : oldTypes.filter( itemId => itemId != id );

            sticker.set( 'types', newTypes );

            const ids = hashify( newTypes );
            this.$( '.-toggle-all' )[0].checked = 
                getAvailableFilteredTypeIds.call( this, filtered ).every( typeId => ids[typeId] );
        },

        'click .-toggle-all'({currentTarget}) {
            const { sticker } = this.options;

            // contains ids of types that can be
            // checked/unchecked by current user
            const ids = getAvailableFilteredTypeIds.call( this, this.options.filtered );

            const h = hashify( ids );
            const drained = sticker.get( 'types' )
                .filter( id => !h[id] )

            const value = currentTarget.checked;
            sticker.set( 'types', value
                ? [...drained, ...ids]
                : [...drained] );

            const values = hashify( sticker.get( 'types' ) );
            this.$( '.-toggle-binding' ).toArray()
                .forEach( el => el.checked = !!values[el.dataset.id] )
        }

    },

    [RefBooksModule.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            this.reFilterGrid(),
            this.navigated();
    },

    [RefBooksModule.event( 'Search:search')](search) {
        return this.setState( { search, page: 1, } ), 
            this.reFilterGrid(),
            this.navigated();
    },

}, {

    OPEN_STICKER,

} );





function getAvailableFilteredTypeIds(typeCollection) {
    const { sticker } = this.options;
    const models = typeCollection instanceof Collection
        ? typeCollection.models
        : typeCollection;

    return models
        // ignore unavailable (disabled) checkboxes
        .filter( type => 
            // chief admin may check any type
            // (local types of wrong cluster do not pass filtration)
            roleA.includes( Config.role() ) ||
            // local types may be checked anyway
            // (local types of wrong cluster do not pass filtration)
            type.get( 'cluster' ) ||
            // local sticker may be joined to any type
            // (local types of wrong cluster do not pass filtration)
            sticker.get( 'cluster' ) )
        .map( type => type.id );
}



// WEBPACK FOOTER //
// ./src/js/module/refbooks/stickers.form.js